var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"absolute top-0 left-0 p-4 z-50"},[_c('router-link',{attrs:{"to":{ path: '/' },"aria-label":"Koivu"}},[_c('img',{staticClass:"h-8 lg:h-14",attrs:{"alt":"Koivu Logo","src":require("@/assets/koivu-logo.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }